import { getPublicRouteUrl } from '@nackle/service-urls';

function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

function getURL( url ) {
    const env = getEnvironment();
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const cypherURL = getPublicRouteUrl( 'CYPHER' );
export const featuresURL = getPublicRouteUrl( 'FEATURES_SERVICE' );
export const rosterGroupHatchUrl = getURL( 'https://(env.)roster-groups.biw.cloud' );
